/* TypeScript file generated from NavBar.re by genType. */
/* eslint-disable import/first */


import * as React from 'react';

// tslint:disable-next-line:no-var-requires
const NavBarBS = require('./NavBar.bs');

import {style as ReactDOMRe_style} from '../../src/shims/ReactDOMRe.shim';

// tslint:disable-next-line:interface-over-type-literal
export type Props = {
  readonly className?: string; 
  readonly fixed?: boolean; 
  readonly headerLeft?: JSX.Element; 
  readonly headerRight?: JSX.Element; 
  readonly headerTitle?: JSX.Element; 
  readonly style?: ReactDOMRe_style; 
  readonly testID?: string
};

export const $$default: React.ComponentType<{
  readonly className?: string; 
  readonly fixed?: boolean; 
  readonly headerLeft?: JSX.Element; 
  readonly headerRight?: JSX.Element; 
  readonly headerTitle?: JSX.Element; 
  readonly style?: ReactDOMRe_style; 
  readonly testID?: string
}> = NavBarBS.default;

export default $$default;
